class TaskSelectionController {
  constructor($rootScope, $scope, $uibModalInstance, TimesheetService) {
    "ngInject";

    let self = this;
    this.timesheetService = TimesheetService;

    this.tasks = [
       {
        displayName: 'Name',
        value: 'name',
        sortable: true,
        dataType: 'text',
        formatting: function (record) {
          return record.name;
        }
      },
      {
        displayName: 'Description',
        value: 'description',
        sortable: true,
        dataType: 'text',
        formatting: function (record) {
          if(record.description) {
            return record.description;
          } else {
            return '';
          }
        }
      },
      {
        displayName: 'Type',
        value: 'name',
        sortable: true,
        dataType: 'text',
        formatting: function (record) {
          if(record.billable === true) {
           return 'Billable';
          } else {
            if(record.leaveType === true) {
              return 'Leave';
            } else {
              return 'Internal';
            }
          }
        }
      },
      {
        displayName: '',
        value: 'name',
        sortable: false,
        dataType: 'text',
        formatting: function (record) {
          return "<button class=\"btn btn-xs btn-primary\">Add</button>";
        },
        clickFunction: function (record) {
          self.$uibModalInstance.addChargeCode(record);
        },
        disableClickFunction: function (record) {
          return self.$uibModalInstance.chargeCodeAlreadyAdded(record);
        }
      }
    ];

    this.showTaskRequestBox = false;
    this.taskRequestText = '';
    this.$uibModalInstance = $uibModalInstance;
    this.taskFilterRefresh = false;
    this.taskFilter = {
      name: '',
    }

    this.taskFilterCriteria = function () {
      return "";
    }
  }

  requestTask() {
    this.$uibModalInstance.requestTask(this.taskRequestText);
  }


}

export default TaskSelectionController;



// WEBPACK FOOTER //
// ./client/pages/timesheet/modals/task-selection/task-selection.controller.js